'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import Link from 'next/link'
import { Button } from '@/components/ui/button'

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <h2 className="text-2xl font-bold text-charcoal mb-3">Something went wrong</h2>
        <p className="text-warm-gray mb-8">
          We hit an unexpected error. Our team has been notified. You can try again or go back to the
          home page.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={reset}
            className="bg-primary hover:bg-primary/90 text-white"
          >
            Try again
          </Button>
          <Link href="/help">
            <Button variant="outline" className="border-gray-300 text-charcoal hover:bg-gray-50">
              Go to help
            </Button>
          </Link>
        </div>
        {error.digest && (
          <p className="mt-6 text-xs text-warm-gray">Error ID: {error.digest}</p>
        )}
      </div>
    </div>
  )
}
